import PolicyFeeStore from "../../../../../stores/policy-fee-store";
import { RETURN_LABEL_FEE_PAYMENT } from "../../../../../../../models/User";
import { SelectDropdown } from "../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { observer } from "mobx-react";
import { FEE_PAYMENT_OPTIONS } from "../../../../../constants";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import { PROFILE_CAPABILITIES } from "../../../../../../../models/ProfileCapabilities";
import ResolveCapability from "../../../../../../../components/resolve-capability/resolve-capability";

interface IProps {
    fee: PolicyFeeStore;
    validationGroup: IValidationGroup;
}

const FeePaymentSelector: React.FC<IProps> = observer(({ fee, validationGroup }) => (
    <ResolveCapability capability={PROFILE_CAPABILITIES.RETURN_LABEL_FEE_PAYMENT}>
        {({ isChargeOptionSupported, isDeductOptionSupported }) => (
            <SelectDropdown
                options={FEE_PAYMENT_OPTIONS.map(option => ({
                    ...option,
                    disabled: (
						option.value === RETURN_LABEL_FEE_PAYMENT.ALWAYS_CHARGE && !isChargeOptionSupported
                    ) || (
						option.value === RETURN_LABEL_FEE_PAYMENT.DEDUCT_FROM_REFUNDS && !isDeductOptionSupported
                    )
                }))}
                value={FEE_PAYMENT_OPTIONS.find(o => o.value === fee.policy.returnLabelFeePayment)}
                onChange={(v) => fee.policy.setReturnLabelFeePayment(v?.value as RETURN_LABEL_FEE_PAYMENT)}
                validationGroup={validationGroup}
                required
                isSearchable={false}
            />
        )}
    </ResolveCapability>
));

export default FeePaymentSelector;
